import { createAsyncThunk } from "@reduxjs/toolkit"

import { OrgStageHasPendingIssuerStages, getOrgStageByOrgStageId, getOrganizationStages, getOrganizationStagesByOrgId, postOrganizationStage, postOrganizationStagesByOrgId, processOrganizationStagesByOrgId, updateOrgStage } from "./cruds"

export const ACTION_TYPE_PARENT = "OrganizationStages"

// * returns the list of organization stages
export const fetchOrganizationStages = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/fetchOrganizationStages`,
  async ({ requestHeaders }: any, { rejectWithValue }) => {
    try {
      const response = await getOrganizationStages(requestHeaders)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchOrganizationStagesByOrgId = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/fetchOrganizationStagesByOrgId`,
  async (organizationStageId: any, { rejectWithValue }) => {
    try {
      const response = await getOrganizationStagesByOrgId(organizationStageId)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const submitOrganizationStagesByOrgId = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/submitOrganizationStagesByOrgId`,
  async ({ organizationStageId, payload }: any, { rejectWithValue }) => {
    try {
      const response = await postOrganizationStagesByOrgId(organizationStageId, payload)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      
      return rejectWithValue({ error: err.response.data, code: err.code, message: err.message })
    }
  }
)

export const createOrganizationStagesByOrgId = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/createOrganizationStagesByOrgId`,
  async ({ organizationStageId, payload }: any, { rejectWithValue }) => {
    try {
      const response = await processOrganizationStagesByOrgId(organizationStageId, payload)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const checkOrgStageHasPendingIssuerStages = createAsyncThunk(`${ACTION_TYPE_PARENT}/checkOrgStageHasPendingIssuerStages`,
  async (organizationStageId: any, { rejectWithValue }) => {
    try {
      const response = await OrgStageHasPendingIssuerStages(organizationStageId)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const fetchOrgStageByOrgStageId = createAsyncThunk(`${ACTION_TYPE_PARENT}/fetchOrgStageByOrgStageId`,
  async (organizationStageId: any, { rejectWithValue }) => {
    try {
      const response = await getOrgStageByOrgStageId(organizationStageId)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

export const editOrgStage = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/editOrgStage`,
  async ({ organizationStageId, payload }: any, { rejectWithValue }) => {
    try {
      const response = await updateOrgStage(organizationStageId, payload)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.message })
    }
  }
)

// * post organization stage
export const createOrganizationStage = createAsyncThunk(
  `${ACTION_TYPE_PARENT}/createOrganizationStage`,
  async ({ payload, params }: any, { rejectWithValue }) => {
    try {
      const response = await postOrganizationStage(payload, params)
      return response.data
    } catch (err: any) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue({ status: err.response.status, code: err.code, message: err.response.data?.title ?? err.response.data, errors: err.response.data?.errors })
    }
  }
)